import { themeStyle } from "../../components/Components";
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";

import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import Paper from "@mui/material/Paper";
import Fab from "@mui/material/Fab";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import PublishIcon from "@mui/icons-material/Publish";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import AttachFileIcon from "@mui/icons-material/AttachFile";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function SettingsBilling() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [open, setOpen] = React.useState(false);

  function onFileUpload() {
    if (!selectedFile.type.match("image.*")) {
      createAlert("error", "Error", "Please select an image file");
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile, selectedFile.name);
    var profilPicName = state.auth.user.user_id + makeid(5) + ".jpg";
    formData.append("user_id", state.auth.user.user_id);
    formData.append("user_image", profilPicName); // Details of the uploaded file
    console.log(selectedFile);

    // Request made to the backend api
    // Send formData object

    const config = {
      headers: {
        Authorization: state.auth.token,

        // "Content-Type": "application/json",
      },
    };
    var time = new Date();

    axios
      .post(API_URL + "/upload_profile_picture", formData, config)
      .then(() => {
        window.location.reload();
      });

    document.getElementById("contained-button-file").value = "";
  }

  function onFileChange(event) {
    setSelectedFile(event.target.files[0]);
  }

  function onFileClick(event) {
    document.getElementById("contained-button-file").value = "";
  }

  const [selectedFile, setSelectedFile] = useState("");
  useEffect(() => {
    if (selectedFile) {
      onFileUpload();
    }
  }, [selectedFile]);

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      return (
        <Fragment>
          <Sidebar />

          <div
            style={{
              margin: "90px 10px 20px 100px",
              backgroundColor: "white",
            }}
          >
            <Grid container spacing={3}>
              <Grid item md={4}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    borderRadius: "25px",
                    padding: "25px",
                    backgroundColor: themeStyle.primaryColorLight,
                  }}
                >
                  <div>
                    <input
                      id="contained-button-file"
                      style={{
                        display: "none",
                        height: "150px",
                        cursor: "pointer",
                        width: "150px",
                      }}
                      type="file"
                      onChange={(e) => onFileChange(e)}
                      onClick={(e) => onFileClick(e)}
                    />
                    <label
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      htmlFor="contained-button-file"
                    >
                      <Avatar
                        style={{
                          height: "100px",
                          width: "100px",
                          cursor: "pointer",
                        }}
                        alt={state.auth.user.full_name}
                        src={API_URL + "/media/" + state.auth.user.user_image}
                      />
                      <h5 style={{ textAlign: "center", marginTop: "5px" }}>
                        UPLOAD PHOTO
                      </h5>
                    </label>
                  </div>
                  <div style={{ marginTop: "-25px", marginLeft: "40px" }}>
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "20px",
                        color: themeStyle.primaryColor,
                      }}
                    >
                      {state.auth.user.full_name}
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        color: themeStyle.primaryColor,
                      }}
                    >
                      Onboarding Department
                    </div>
                    <br />
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        color: "black",
                      }}
                    >
                      {state.auth.user.email}
                    </div>{" "}
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "16px",
                        color: "grey",
                      }}
                    >
                      {state.auth.user.phone_number}
                    </div>
                  </div>
                </div>
                <br />
                <div
                  style={{
                    width: "100%",
                    borderRadius: "25px",
                    padding: "25px",
                    backgroundColor: themeStyle.primaryColorLight,
                  }}
                >
                  <div
                    style={{ color: themeStyle.primaryColor, fontSize: "25px" }}
                  >
                    Change Password
                  </div>
                  <div style={{ marginTop: "20px", width: "100%" }}>
                    <TextField
                      style={{
                        width: "100%",
                      }}
                      fullWidth
                      variant="outlined"
                      type="password"
                      label="Old Password"
                      name="old_password"
                      required
                    />
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <TextField
                      style={{
                        width: "100%",
                      }}
                      variant="outlined"
                      type="password"
                      label="New Password"
                      name="new_password"
                      required
                    />
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <TextField
                      style={{
                        width: "100%",
                      }}
                      variant="outlined"
                      type="password"
                      label="New Password Confirmation"
                      name="new_password_confirmation"
                      required
                    />
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <Button
                      variant="contained"
                      style={{
                        width: "100%",
                        backgroundColor: themeStyle.primaryColor,
                        fontFamily: "Campton Book",
                      }}
                      type="submit"
                    >
                      CHANGE PASSWORD
                    </Button>
                  </div>
                </div>
              </Grid>
              <Grid item md={4}>
                <div
                  style={{
                    width: "100%",
                    borderRadius: "25px",
                    padding: "25px",
                    backgroundColor: themeStyle.primaryColorLight,
                  }}
                >
                  <div
                    style={{ color: themeStyle.primaryColor, fontSize: "25px" }}
                  >
                    Personal Information
                  </div>
                  <div style={{ marginTop: "20px", width: "100%" }}>
                    <TextField
                      style={{
                        width: "100%",
                      }}
                      fullWidth
                      variant="outlined"
                      type="email"
                      label="Email"
                      name="email"
                      defaultValue={state.auth.user.email}
                      required
                    />
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <TextField
                      style={{
                        width: "100%",
                      }}
                      variant="outlined"
                      type="tel"
                      label="Phone Number"
                      name="phone_number"
                      defaultValue={state.auth.user.phone_number}
                      required
                    />
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <TextField
                      style={{
                        width: "100%",
                      }}
                      variant="outlined"
                      type="date"
                      label="Birth Date"
                      name="birthdate"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                    />
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <Button
                      variant="contained"
                      style={{
                        width: "100%",
                        backgroundColor: themeStyle.primaryColor,
                        fontFamily: "Campton Book",
                      }}
                      type="submit"
                    >
                      UPDATE INFORMATION
                    </Button>
                  </div>
                </div>
              </Grid>
              <Grid item md={4}>
                <div
                  style={{
                    width: "100%",
                    borderRadius: "25px",
                    padding: "25px",
                    backgroundColor: themeStyle.primaryColorLight,
                  }}
                >
                  <div
                    style={{ color: themeStyle.primaryColor, fontSize: "25px" }}
                  >
                    Recent Activity
                  </div>
                  <br />
                  <div style={{ marginBottom: "15px" }}>
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontWeight: "bold",
                        fontFamily: "Campton Book",
                      }}
                    >
                      Last Login Details
                    </Typography>
                    {/* <Typography variant="body2">
                      IP Address:{" "}
                      {state.auth.user.activity[0]["ip"] || "Not available"}
                    </Typography>
                    <Typography variant="body2">
                      Browser:{" "}
                      {state.auth.user.activity[0]["agent"] || "Not available"}
                    </Typography>
                    <Typography variant="body2">
                      Device:{" "}
                      {state.auth.user.activity[0]["device"] || "Not available"}
                    </Typography>
                    <Typography variant="body2">
                      Time:{" "}
                      {state.auth.user.activity[0]["time"] || "Not available"}
                    </Typography> */}
                  </div>
                  <div style={{ marginTop: "15px" }}>
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontWeight: "bold",
                        fontFamily: "Campton Book",
                        marginBottom: "10px",
                      }}
                    >
                      Recent Activities
                    </Typography>
                    {/* {state.auth.user.activity.map((activity, index) => (
                      <div key={index} style={{ marginBottom: "8px" }}>
                        <Typography variant="body2" style={{ color: "#666" }}>
                          {activity.type}
                        </Typography>
                        <Typography variant="caption" style={{ color: "#999" }}>
                          {new Date(activity.timestamp).toLocaleString()}
                        </Typography>
                      </div>
                    ))} */}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Fragment>
      );
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default SettingsBilling;
